import React from 'react'

import { Subsection, Upload, useMediaQueryContext } from '@fourthwall/components'
import { UploadIcon } from '@fourthwall/icons'

import { RemovableUpload, UploadedImage } from '../../../../components'
import { useSingleSeriesContext } from '../../hooks/useSingleSeriesContext'
import { FormFields } from '../../providers/SingleSeriesProvider/types'
import * as S from './styled'

export const ThumbnailFields = () => {
  const media = useMediaQueryContext()
  const { form, handleUploadThumbnailImage, isThumbnailImageUploading } = useSingleSeriesContext()

  const handleFileDrop = async (files?: File[]) => {
    if (!files?.[0]) return

    await handleUploadThumbnailImage(files[0])
  }

  const renderUpload = () => {
    if (form.values.thumbnailImage) {
      return (
        <S.UploadOrImageContainer>
          <RemovableUpload
            onRemove={() => {
              form.setFieldValue(FormFields.thumbnailImage, '')
            }}
          >
            <UploadedImage image={form.values.thumbnailImage} />
          </RemovableUpload>
        </S.UploadOrImageContainer>
      )
    }

    return (
      <S.UploadOrImageContainer>
        <Upload
          accept={{
            'image/*': [],
          }}
          title={
            media.tablet ? (
              <span>
                Drop image or <u>browse</u>
              </span>
            ) : (
              'Browse'
            )
          }
          icon={UploadIcon}
          iconSize={20}
          maxSize={10485760}
          orientation="vertical"
          onFileDrop={handleFileDrop}
          isUploading={isThumbnailImageUploading}
        />
      </S.UploadOrImageContainer>
    )
  }

  return (
    <Subsection title="Thumbnail">
      <S.Container>
        {renderUpload()}
        <S.ImageInfo>
          Primary visual for video series. Appears in the video catalog on the video series list
          section.
          <S.ImageInfoRecommendedSize>Recommended size: 600 x 900 px</S.ImageInfoRecommendedSize>
        </S.ImageInfo>
      </S.Container>
    </Subsection>
  )
}
